import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const BarrierefreiheitPage = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white border-b border-slate-200">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center">
              <img 
                src="/assets/logo/city-battery-horizontal.svg" 
                alt="city-battery.energy" 
                className="h-[26px] sm:h-[32px] w-auto"
              />
            </Link>
            <Link 
              to="/" 
              className="flex items-center gap-2 text-sm text-slate-600 hover:text-cyan-700 transition-colors"
            >
              <ArrowLeft className="w-4 h-4" />
              <span className="hidden sm:inline">Zurück zur Startseite</span>
              <span className="sm:hidden">Zurück</span>
            </Link>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <article className="prose prose-slate max-w-none">
          <h1 className="text-3xl sm:text-4xl font-semibold text-slate-800 mb-8">Erklärung zur Barrierefreiheit</h1>
          
          <section className="mb-10">
            <p className="text-slate-600 leading-relaxed mb-4">
              Die DSG Beteiligungs- und Verwaltungsgesellschaft mbH ist bemüht, ihre Website möglichst barrierefrei zugänglich zu machen und kontinuierlich zu verbessern.
            </p>
            <p className="text-slate-600 leading-relaxed">
              Diese Erklärung zur Barrierefreiheit gilt für die Website:<br />
              <a href="https://city-battery.energy/" className="text-cyan-700 hover:text-cyan-800">https://city-battery.energy/</a>
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-xl sm:text-2xl font-semibold text-slate-800 mb-4">Stand der Vereinbarkeit mit den Anforderungen</h2>
            <p className="text-slate-600 leading-relaxed mb-4">
              Diese Website orientiert sich an den Anforderungen der Barrierefreie-Informationstechnik-Verordnung (BITV 2.0) sowie an den internationalen Richtlinien der Web Content Accessibility Guidelines (WCAG).
            </p>
            <p className="text-slate-600 leading-relaxed">
              Wir arbeiten kontinuierlich daran, die Barrierefreiheit unserer Website weiter zu verbessern. Derzeit bestehen noch vereinzelt Barrieren, die im Rahmen der laufenden Weiterentwicklung reduziert werden.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-xl sm:text-2xl font-semibold text-slate-800 mb-4">Maßnahmen zur Barrierefreiheit</h2>
            <p className="text-slate-600 leading-relaxed mb-4">
              Zur Verbesserung der Zugänglichkeit wurden unter anderem folgende Maßnahmen umgesetzt:
            </p>
            <ul className="list-disc list-inside text-slate-600 space-y-2">
              <li>strukturierte Seiteninhalte und nachvollziehbare Navigationslogik</li>
              <li>Bedienbarkeit über Tastatur (Tab-Navigation)</li>
              <li>Alternativtexte für relevante Bilder</li>
              <li>ausreichende Farbkontraste zur besseren Lesbarkeit</li>
              <li>responsive Darstellung für unterschiedliche Endgeräte</li>
            </ul>
          </section>

          <section className="mb-10">
            <h2 className="text-xl sm:text-2xl font-semibold text-slate-800 mb-4">Feedback und Kontakt</h2>
            <p className="text-slate-600 leading-relaxed mb-4">
              Sollten Ihnen Barrieren auf unserer Website auffallen oder benötigen Sie Unterstützung beim Zugriff auf Inhalte, kontaktieren Sie uns gerne:
            </p>
            <p className="text-slate-600 leading-relaxed">
              <strong>DSG Beteiligungs- und Verwaltungsgesellschaft mbH</strong><br />
              E-Mail: <a href="mailto:it@city-battery.energy" className="text-cyan-700 hover:text-cyan-800">it@city-battery.energy</a><br /><br />
              <strong>Telefon:</strong><br />
              <a href="tel:+4917693127245" className="text-cyan-700 hover:text-cyan-800">+49 176 93127245</a><br />
              <a href="tel:+493071047955" className="text-cyan-700 hover:text-cyan-800">+49 30 71047955</a>
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-semibold text-slate-800 mb-4">Aktualisierung dieser Erklärung</h2>
            <p className="text-slate-600 leading-relaxed">
              Diese Erklärung wird regelmäßig überprüft und bei Bedarf aktualisiert.
            </p>
          </section>
        </article>
      </main>

      {/* Footer */}
      <footer className="bg-slate-100 border-t border-slate-200">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-sm text-slate-500">© 2026 DSG Beteiligungs- und Verwaltungsgesellschaft mbH — Design & Umsetzung: webionik</p>
            <div className="flex gap-6">
              <Link to="/impressum" className="text-sm text-slate-500 hover:text-cyan-700">Impressum</Link>
              <Link to="/datenschutz" className="text-sm text-slate-500 hover:text-cyan-700">Datenschutz</Link>
              <Link to="/barrierefreiheit" className="text-sm text-slate-500 hover:text-cyan-700">Barrierefreiheit</Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default BarrierefreiheitPage;
